export default __webpack_public_path__ + "static/media/vinha.12976e17.PNG";